'use client';

import { SessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';

import { AuthErrorHandler } from '~/components/auth-error-handler';

interface Props {
  children?: ReactNode;
}

export const AuthProvider = (props: Props) => {
  const { children } = props;

  return (
    <SessionProvider>
      <AuthErrorHandler
        routesMatcher={[
          '/((?!404|api|auth|healthz|unauthorized|_next/static|_next/image|assets|favicon.ico|sw.js).*)(.+)',
        ]}
      >
        {children}
      </AuthErrorHandler>
    </SessionProvider>
  );
};
